export const CRITERIA_TYPES = [
  { value: 'org', label: 'Org Membership' },
  { value: 'patientIds', label: 'Patient IDs' },
  { value: 'tag', label: 'Tag Reference' },
  { value: 'salesforce', label: 'Salesforce Query' },
  { value: 'openSearch', label: 'OpenSearch Query' },
  { value: 'jotform', label: 'Jotform' },
]

export const BUTTONS_SCHEMA = {
  type: 'array',
  items: {
    type: 'object',
    properties: {
      title: { type: 'string', description: 'Button label text' },
      action: {
        type: 'string',
        enum: ['link', 'opt_out'],
        description: 'Button action type',
      },
      payload: {
        type: 'object',
        properties: {
          url: { type: 'string', description: 'URL for link action' },
        },
      },
    },
    required: ['title', 'action', 'payload'],
  },
}

export const TEMPLATE_CHANNELS = [
  { value: 'email', label: 'Email' },
  { value: 'highlight_push', label: 'Highlight Push' },
]

export const TEMPLATE_VARIABLES = {
  patient_id: '12345678-1234-1234-1234-123456789abc',
  first_name: 'Jane',
  last_name: 'Doe',
  name: 'Jane Doe',
  email: 'jane.doe@example.com',
  phone_number: '555-012-3456',
  locale: 'en_US',
  zip_code: '94102',
  dob: '1970-05-15',
  dob_day: '15',
  dob_month: '05',
  dob_year: '1970',
  pd_diagnosis_date: '2020-03-10',
  pd_diagnosis_day: '10',
  pd_diagnosis_month: '03',
  pd_diagnosis_year: '2020',
  doctor_name: 'Dr. Smith',
  facility_name: 'City Medical Center',
  clinic_state: 'CA',
  provider_npi: '1234567890',
}

export const TEMPLATE_VARIABLE_LABELS = {
  patient_id: 'Patient ID',
  first_name: 'First Name',
  last_name: 'Last Name',
  name: 'Full Name',
  email: 'Email',
  phone_number: 'Phone Number',
  locale: 'Locale',
  zip_code: 'ZIP Code',
  dob: 'Date of Birth',
  dob_day: 'Birth Day',
  dob_month: 'Birth Month',
  dob_year: 'Birth Year',
  pd_diagnosis_date: 'PD Diagnosis Date',
  pd_diagnosis_day: 'PD Diagnosis Day',
  pd_diagnosis_month: 'PD Diagnosis Month',
  pd_diagnosis_year: 'PD Diagnosis Year',
  doctor_name: 'Doctor Name',
  facility_name: 'Facility Name',
  clinic_state: 'Clinic State',
  provider_npi: 'Provider NPI',
}
